import(/* webpackMode: "eager", webpackExports: ["CardSagra"] */ "/vercel/path0/components/CardSagra.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/link.js");
